import { watch } from '@nuxtjs/composition-api'
import useLocale from './useLocale'

export default function useVeeValidate(context) {
  const { locale } = useLocale()
  watch(locale, () => {
    validate()
  })

  function reset(ref) {
    resetMulti(ref ? [ref] : undefined)
  }
  function validate(ref) {
    validateMulti(ref ? [ref] : undefined)
  }
  function resetMulti(refs) {
    validateMethodMulti(refs)
  }
  function validateMulti(refs) {
    validateMethodMulti(refs, 'validate')
  }
  function validateMethodMulti(refs = ['form'], method = 'reset') {
    requestAnimationFrame(() => {
      refs.forEach(ref => {
        if (context.refs[ref] && context.refs[ref][method]) {
          context.refs[ref][method]()
        }
      })
    })
  }

  return {
    reset,
    validate,
    resetMulti,
    validateMulti
  }
}
